import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import {
    convertStoreSettingsToResource,
    convertStoreSettingsToModel
} from './store-read-settings/store-read-settings.util';
import { BinaryCopySource } from 'app/model/pipeline/copysource/binary.source';
import {
    convertFormatSettingsToModel,
    convertFormatSettingsToResource
} from './format-read-settings/format-read-settings.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(BinaryCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        storeSettings: '*',
        formatSettings: '*'
    }
})
export class BinaryCopySourceAdapter extends CopySourceAdapter<BinaryCopySource, Model.BinarySource> {
    protected override async _toResource(copySource: BinaryCopySource): Promise<Model.BinarySource> {
        const result: Model.BinarySource = this.getCommonCopySourceProperties(copySource, 'BinarySource');
        await convertStoreSettingsToResource(copySource.storeSettings, result, this.context);

        if (!!result.storeSettings) {
            result.storeSettings.enablePartitionDiscovery = undefined;
            result.storeSettings.partitionRootPath = undefined;
        }

        await convertFormatSettingsToResource(copySource.formatSettings, result, this.context);

        return result;
    }

    protected override async _toModel(
        source: Model.BinarySource,
        copyActivity: CopyActivity
    ): Promise<BinaryCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            BinaryCopySource.MODEL,
            source,
            copyActivity
        ) as BinaryCopySource;

        await convertStoreSettingsToModel(source.storeSettings, result, this.context);
        await convertFormatSettingsToModel(source.formatSettings, result, this.context);

        return result;
    }
}
